import styles from "./home.module.css";
import Sidebar from "../../Components/Sidebar";
import { useEffect, useState } from "react";
import api from "../../api";

const ITENS_TIMELINE = 10;

const ICONE = { curtida: "👍", amei: "❤️", comentario: "💬", visualizacao: "👁️" };
const LABEL = { curtida: "Curtiu", amei: "Amei", comentario: "Comentou", visualizacao: "Visualizou" };

const COR_AVATAR = [
    "#e11d48", "#7c3aed", "#0284c7", "#059669",
    "#d97706", "#db2777", "#2563eb", "#16a34a",
];

const TIPO_MAP = { amecom: "amei" };

function normalizarTipo(tipo) {
    const t = (tipo ?? "").toLowerCase();
    return TIPO_MAP[t] ?? t;
}

function corAvatar(nome = "") {
    const idx = nome.charCodeAt(0) % COR_AVATAR.length;
    return COR_AVATAR[idx];
}

function iniciais(nome = "") {
    return nome.split(" ").slice(0, 2).map(p => p[0]).join("").toUpperCase();
}

function toDDMMYYYY(iso) {
    if (!iso) return "0";
    const [y, m, d] = iso.split("-");
    return `${d}/${m}/${y}`;
}

function getSemanaAtual() {
    const hoje = new Date();
    const dow = hoje.getDay();
    const diffSeg = dow === 0 ? -6 : 1 - dow;
    const seg = new Date(hoje);
    seg.setDate(hoje.getDate() + diffSeg);
    const sex = new Date(seg);
    sex.setDate(seg.getDate() + 4);
    const fmt = d => d.toISOString().slice(0, 10);
    const fmtBR = d => d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
    return {
        datini: fmt(seg),
        datfin: fmt(sex),
        labelPeriodo: `${fmtBR(seg)} a ${fmtBR(sex)}`,
    };
}

export default function Home() {
    const { datini, datfin, labelPeriodo } = getSemanaAtual();

    const [comunicados, setComunicados] = useState([]);
    const [interacoes, setInteracoes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [paginaTimeline, setPaginaTimeline] = useState(1);
    const [filtroNome, setFiltroNome] = useState("");
    const [filtroData, setFiltroData] = useState("");

    async function carregarDados() {
        // dd/mm/yyyy — padrão brasileiro
        const hoje = new Date().toISOString().slice(0, 10);
       
        
        try {
            setLoading(true);
            const [resCom, resInt] = await Promise.all([
                api.get(`/portal/comunicado/?datini=${toDDMMYYYY(datini)}&datfin=${toDDMMYYYY(datfin)}`),
                api.get(`/portal/interacoes/?codcom=0&datini=${toDDMMYYYY(datini)}&datfin=${toDDMMYYYY(datfin)}`),
            ]);
            setComunicados(Array.isArray(resCom.data) ? resCom.data : []);
            setInteracoes(Array.isArray(resInt.data)
                ? resInt.data.map(i => ({ ...i, tipo: normalizarTipo(i.tipo) }))
                : []);
        } catch (error) {
            alert("Erro ao carregar dados: " + error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        carregarDados();
    }, []);

    const totalInteracoes = interacoes.length;
    const totalComentarios = interacoes.filter(i => i.tipo === "comentario").length;
    const totalCurtidas = interacoes.filter(i => i.tipo === "curtida" || i.tipo === "amei").length;

    const interacoesFiltradas = interacoes.filter(i => {
        const nomeOk = filtroNome === "" || (i.nomfun ?? "").toLowerCase().includes(filtroNome.toLowerCase());
        const dataOk = filtroData === "" || (i.datint ?? "").includes(toDDMMYYYY(filtroData));
        return nomeOk && dataOk;
    });

    const totalPaginas = Math.ceil(interacoesFiltradas.length / ITENS_TIMELINE);
    const interacoesPagina = interacoesFiltradas.slice(
        (paginaTimeline - 1) * ITENS_TIMELINE,
        paginaTimeline * ITENS_TIMELINE
    );

    function handleLimparFiltro() {
        setFiltroNome("");
        setFiltroData("");
        setPaginaTimeline(1);
    }

    function stripHtml(html) {
        if (!html) return "";
        return html.replace(/<[^>]*>/g, "").trim();
    }

    function tituloComunicado(item) {
        if (item.titcom) return stripHtml(item.titcom);
        const com = comunicados.find(c => String(c.codcom) === String(item.codcom));
        return stripHtml(com?.titcom ?? "");
    }

    return (
        <div className={styles.layout}>
            <Sidebar />
            <div className={styles.main}>
                <div className={styles.content}>

                    {/* CABEÇALHO */}
                    <div className={styles.pageHeader}>
                        <div>
                            <span className={styles.pageLabel}>Comunicação</span>
                            <h1 className={styles.pageTitle}>Dashboard</h1>
                            <p className={styles.pageSubtitle}>Semana atual · {labelPeriodo}</p>
                        </div>
                        <div className={styles.headerAcoes}>
                            {loading
                                ? <span className={styles.loadingBadge}>Carregando...</span>
                                : <button className={styles.btnRefresh} onClick={carregarDados} title="Atualizar dados">↻ Atualizar</button>
                            }
                        </div>
                    </div>

                    {/* CARDS */}
                    <div className={styles.cards}>
                        <div className={styles.card}>
                            <div className={styles.cardIcone} style={{ background: "#fff0f3" }}>📢</div>
                            <div>
                                <span>Comunicados</span>
                                <strong>{comunicados.length}</strong>
                            </div>
                        </div>
                        <div className={styles.card}>
                            <div className={styles.cardIcone} style={{ background: "#f0f9ff" }}>⚡</div>
                            <div>
                                <span>Interações</span>
                                <strong>{totalInteracoes}</strong>
                            </div>
                        </div>
                        <div className={styles.card}>
                            <div className={styles.cardIcone} style={{ background: "#f0fdf4" }}>💬</div>
                            <div>
                                <span>Comentários</span>
                                <strong>{totalComentarios}</strong>
                            </div>
                        </div>
                        <div className={styles.card}>
                            <div className={styles.cardIcone} style={{ background: "#fdf4ff" }}>❤️</div>
                            <div>
                                <span>Curtidas + Amei</span>
                                <strong>{totalCurtidas}</strong>
                            </div>
                        </div>
                    </div>

                    {/* FILTRO ATIVIDADES */}
                    {!loading && <div className={styles.filtrosBar}>
                        <div className={styles.filtroGrupo}>
                            <label>Nome</label>
                            <input
                                type="text"
                                placeholder="Buscar por nome..."
                                value={filtroNome}
                                onChange={e => { setFiltroNome(e.target.value); setPaginaTimeline(1); }}
                            />
                        </div>
                        <div className={styles.filtroGrupo}>
                            <label>Data da interação</label>
                            <input
                                type="date"
                                value={filtroData}
                                onChange={e => { setFiltroData(e.target.value); setPaginaTimeline(1); }}
                            />
                        </div>
                        {(filtroNome || filtroData) && (
                            <button className={styles.btnLimpar} onClick={handleLimparFiltro}>
                                Limpar
                            </button>
                        )}
                        {(filtroNome || filtroData) && (
                            <span className={styles.resultadoBadge}>
                                {interacoesFiltradas.length} resultado{interacoesFiltradas.length !== 1 ? "s" : ""}
                            </span>
                        )}
                    </div>}

                    {/* TIMELINE */}
                    <div className={styles.timelineContainer}>
                        <div className={styles.timelineHeader}>
                            <h3>Atividades recentes</h3>
                            {interacoes.length > 0 && (
                                <span className={styles.totalBadge}>{interacoes.length} registros</span>
                            )}
                        </div>

                        {!loading && interacoesFiltradas.length === 0 && (
                            <p className={styles.vazio}>
                                {interacoes.length === 0 ? "Nenhuma atividade na semana." : "Nenhum resultado para o filtro aplicado."}
                            </p>
                        )}

                        <div className={styles.timeline}>
                            {loading && Array.from({ length: 6 }).map((_, i) => (
                                <div key={i} className={styles.skeletonItem}>
                                    <div className={styles.skeletonAvatar} />
                                    <div className={styles.skeletonContent}>
                                        <div className={styles.skeletonLinha} style={{ width: "60%" }} />
                                        <div className={styles.skeletonLinha} style={{ width: "40%" }} />
                                    </div>
                                </div>
                            ))}

                            {!loading && interacoesPagina.map((item, index) => (
                                <div key={index} className={styles.timelineItem}>
                                    <div
                                        className={styles.avatar}
                                        style={{ background: corAvatar(item.nomfun) }}
                                    >
                                        {iniciais(item.nomfun)}
                                    </div>
                                    <div className={styles.timelineContent}>
                                        <p>
                                            <strong>{item.nomfun}</strong>
                                            <span className={styles.acao}> {LABEL[item.tipo] ?? item.tipo} </span>
                                            o comunicado
                                            {tituloComunicado(item) && (
                                                <span className={styles.postTitle}> "{tituloComunicado(item)}"</span>
                                            )}
                                        </p>
                                        {item.tipo === "comentario" && item.tipint && (
                                            <p className={styles.comentarioTexto}>"{item.tipint}"</p>
                                        )}
                                        <div className={styles.timelineMeta}>
                                            <span>{ICONE[item.tipo]} {LABEL[item.tipo] ?? item.tipo}</span>
                                            <span>{item.datint}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {totalPaginas > 1 && (
                            <div className={styles.paginacao}>
                                <button
                                    className={styles.btnPagina}
                                    onClick={() => setPaginaTimeline(p => p - 1)}
                                    disabled={paginaTimeline === 1}
                                >
                                    ‹ Anterior
                                </button>
                                {Array.from({ length: totalPaginas }, (_, i) => i + 1).map(num => (
                                    <button
                                        key={num}
                                        className={`${styles.btnPagina} ${paginaTimeline === num ? styles.btnPaginaAtivo : ""}`}
                                        onClick={() => setPaginaTimeline(num)}
                                    >
                                        {num}
                                    </button>
                                ))}
                                <button
                                    className={styles.btnPagina}
                                    onClick={() => setPaginaTimeline(p => p + 1)}
                                    disabled={paginaTimeline === totalPaginas}
                                >
                                    Próximo ›
                                </button>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
}
